const ITEMS = ["Weddings", "Corporate Galas", "Private Parties", "Beach Celebrations", "Birthdays", "Brand Activations"];

export const Marquee = ({ dark = false }) => (
  <div
    className={`overflow-hidden py-8 border-y ${
      dark ? "bg-[#3c003a] border-white/10" : "bg-[#fafaf7] border-black/5"
    }`}
    data-testid="editorial-marquee"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0">
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center">
              <span
                className={`font-serif italic text-2xl md:text-3xl px-8 whitespace-nowrap ${
                  dark ? "text-[#ffc4e4]" : "text-[#91008d]"
                }`}
              >
                {item}
              </span>
              <span className="text-[#c9006f] text-xl">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
